export function resourcesHeroSlider() {
    let $resourcesSlider = $(".resources-hero-slider");
    let $bgSlider = $(".section-bg-slider");

    $resourcesSlider.slick({
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        dots: true,
        arrows: false,
        asNavFor: $bgSlider,
        appendDots: ".resources-hero-dots",
    });

    $bgSlider.slick({
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        dots: false,
        arrows: false,
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/resourcesHeroSlider.js